export default __webpack_public_path__ + "static/media/girl9.31a1ed2b.jpg";